var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin registration-page"},[(!_vm.showVerifyForm)?_c('change-email-form',{attrs:{"submit":_vm.changeEmail}}):_vm._e(),_vm._v(" "),(_vm.showVerifyForm)?_c('verify-changed-email-form',{attrs:{"submit":_vm.verifyChangedEmail,"email":this.email}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }